import { getPatternStyles, patternFns } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const starRatingRootConfig = {
transform(props, { map, isCssUnit, isCssVar }) {
  const { size, gap, color, ...rest } = props;
  const tokenMapFn = (category, prefix) => map(
    category,
    (v) => isCssUnit(v) || isCssVar(v) ? v : `token(${prefix}.${v}, ${v})`
  );
  return {
    "--star-rating-size": tokenMapFn(size, "sizes"),
    "--star-rating-gap": tokenMapFn(gap, "spacing"),
    "--star-rating-color-fill": tokenMapFn(color, "colors"),
    ...rest
  };
},
defaultValues:{size:'icon.medium',gap:'0.15rem',color:'greens.main'}}

export const getStarRatingRootStyle = (styles = {}) => {
  const _styles = getPatternStyles(starRatingRootConfig, styles)
  return starRatingRootConfig.transform(_styles, patternFns)
}

export const starRatingRoot = (styles) => css(getStarRatingRootStyle(styles))
starRatingRoot.raw = getStarRatingRootStyle